import { unaryRpc } from "@redotech/rpc/definition";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const createMarketplaceCheckoutSession = unaryRpc({
  name: "createMarketplaceCheckoutSession" as const,
  input: z.object({
    cartId: zExt.objectId(),
    customerEmail: z.email(),
    currency: z.string().length(3).default("USD"),
  }),
  output: z.object({
    checkoutUrl: z.url(),
    sessionId: z.string(),
    totalAmount: z.number(),
    marketplaceOrderId: zExt.objectId(),
    merchantOrderIds: z.array(zExt.objectId()),
  }),
});
